import { Search, User, Globe } from 'lucide-react';
import {
  SearchCard,
  PersonResult,
  PhotoResult,
  AnythingResult,
  SubscriptionPlan,
  Testimonial,
  SettingItem,
} from './types';

// Dashboard search cards
export const searchCards: SearchCard[] = [
  {
    id: '1',
    type: 'search-by-photo',
    title: 'Search by Photo',
    description: 'Search by uploading a picture and scan for similar ones.',
    icon: <Search className="w-6 h-6 text-gray-600" />,
    iconBg: 'bg-gray-100',
    enabled: true,
  },
  {
    id: '2',
    type: 'person-search',
    title: 'Search by Person',
    description: 'Search for a person by name and find their online footprint.',
    icon: <User className="w-6 h-6 text-green-600" />,
    iconBg: 'bg-green-100',
    enabled: true,
  },
  {
    id: '3',
    type: 'search-anything',
    title: 'Search anything',
    description: 'Run a full online presence scan on',
    icon: <Globe className="w-6 h-6 text-blue-600" />,
    iconBg: 'bg-blue-100',
    enabled: true,
  },
];
// Subscription plans
export const subscriptionPlans: SubscriptionPlan[] = [
  {
    id: 'pro',
    name: 'Deepcheck Pro',
    price: 999.99,
    period: 'month',
    periodLabel: 'per Month',
    dailyRate: 33.33,
    dailyRateLabel: 'Per Day',
    polarProductId: import.meta.env.VITE_POLAR_PRODUCT_PRO_ID || '4378ea7f-48f1-4bab-9dc6-acdd249eca0c',
    features: [
      'Scan Online Presences',
      'Unlimited searches',
      'Priority support',
      'Advanced filters',
    ],
  },
  {
    id: 'max',
    name: 'Deepcheck Pro',
    price: 2999.99,
    period: 'year',
    periodLabel: 'per year',
    dailyRate: 57.69,
    dailyRateLabel: 'Per week',
    polarProductId: import.meta.env.VITE_POLAR_PRODUCT_MAX_ID || 'ad944ff4-db97-44b7-a5e1-89fa4135a698',
    features: [
      'All Pro features',
      'Advanced analytics',
      'API access',
      'Bulk searches',
      'Export results',
    ],
  },
];

// Testimonials for paywall
export const testimonials: Testimonial[] = [
  {
    id: '1',
    author: 'StarGazer24',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=StarGazer24',
    rating: 5,
    text: "Honestly? It's useful. Not dramatic or flashy, just a simple way to see what's connected to your name. Found a few things I cleaned up. Felt good to be aware.",
  },
  {
    id: '2',
    author: 'Jay Hawkins',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=JayHawkins',
    rating: 5,
    text: 'There were accounts I forgot I even made, Deepcheck found them—some with really old photos. I ended up deleting four of them that were still public.',
  },
  {
    id: '3',
    author: 'TechEnthusiast',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=TechEnthusiast',
    rating: 5,
    text: 'Great tool for managing your digital footprint. Found some old profiles I had completely forgotten about. Highly recommend!',
  },
];

// Settings items
export const settingsItems: SettingItem[] = [
  {
    id: '1',
    type: 'restore',
    label: 'Restore Purchases',
  },
  {
    id: '2',
    type: 'feedback',
    label: 'Feedback',
  },
  {
    id: '3',
    type: 'user-id',
    label: 'User ID',
    value: '4sTBTCIJjwMb4mitK7a6lOzybEjl',
  },
];

